export const getAddButton = (res, role) => {
  let data = res.data.data.workReportList;
  let total = res.data.data.plan_num;
  console.log('TCL: getAddButton -> total', total);
  // 服务商
  console.log(role);
  if (role === 1) {
    if (data.length === total) {
      return false;
    } else {
      return true;
    }
  }
};
